import { useId } from "react";

/**
 * OrkevaMark — official standalone brand mark (single source of truth).
 * Approved geometry: gold circular mark, integrated "K" touching the circle,
 * upper diagonal stroke extending outside the ring as an upward arrow.
 *
 * Renders with a metallic gold gradient by default. Pass a solid `color`
 * (e.g. "#fff") to override the gradient for mono/dark surfaces.
 *
 * To swap in the final official artwork, replace ONLY this component (and
 * public/favicon.svg) — no UI code elsewhere needs to change.
 */
export function OrkevaMark({ size = 32, className = "", color }) {
  const rawId = useId();
  const gid = `orkeva-gold-${rawId.replace(/:/g, "")}`;
  const stroke = color || `url(#${gid})`;
  const s = {
    stroke,
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      className={className}
      role="img"
      aria-label="ORKEVA"
    >
      {!color && (
        <defs>
          <linearGradient id={gid} x1="6" y1="6" x2="42" y2="44" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#EBD293" />
            <stop offset="0.45" stopColor="#CBA451" />
            <stop offset="1" stopColor="#976624" />
          </linearGradient>
        </defs>
      )}
      {/* gold circular mark */}
      <circle cx="21" cy="27" r="16" {...s} strokeWidth="3" />
      {/* integrated K — vertical stem */}
      <path d="M15 17 V37" {...s} />
      {/* K lower diagonal */}
      <path d="M15 27 L26 38" {...s} />
      {/* K upper diagonal / arrow shaft extending outside the ring */}
      <path d="M15 27 L38 8" {...s} />
      {/* upward arrowhead */}
      <path d="M38 8 L29 9 M38 8 L37 17" {...s} />
    </svg>
  );
}
